import React from 'react';
var LogoMarkClearanceSVG = function LogoMarkClearanceSVG(_ref) {
    var width = _ref.width, svgClassName = _ref.svgClassName, clearanceClassName = _ref.clearanceClassName, specsClassName = _ref.specsClassName, specMarkersClassName = _ref.specMarkersClassName, logoClassName = _ref.logoClassName;
    return /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 710 710",
        width: width,
        className: svgClassName
    }, /*#__PURE__*/ React.createElement("g", {
        className: clearanceClassName
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M702.63,106.11H553.51v0.34H253.65v-0.09H104.52v576.76h0.02v18.92h582.95v-0.26h15.15V106.11z M553.51,255.57 v295.74H253.65V255.57H553.51z"
    })), /*#__PURE__*/ React.createElement("g", {
        className: logoClassName
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M493.24,403.63c21.06-6.13,42.69-23.17,51.11-42.01c9.11-20.37,8.71-47.13,8.32-57.12 c-0.4-9.99-1.58-26.76-1.98-32.35c-0.4-5.59-1.28-12.15-5.34-15.13c-2.33-1.71-9-5.19-58.52,11.68 c-39.63,13.5-51.42,43-54.49,54.87c-1.46,5.64-1.46,16.12-1.46,18.84v59.53c0,0.07,0.01,0.15,0.01,0.22c0,0.07-0.01,0.15-0.01,0.22 v64.42c0,5.14,0.62,12.75,2.14,19.09c3.23,11.82,14.18,39.19,53.81,52.69c49.52,16.87,56.2,13.38,58.52,11.68 c4.06-2.98,4.95-9.54,5.34-15.13s1.58-22.37,1.98-32.35c0.4-9.99,0.79-36.75-8.32-57.12C535.93,426.8,514.3,409.76,493.24,403.63z M320.15,268.69c-49.52-16.87-56.2-13.38-58.52-11.68c-4.06,2.98-4.95,9.54-5.34,15.13c-0.4,5.59-1.58,22.37-1.98,32.35 c-0.4,9.99-0.79,36.75,8.32,57.12c8.42,18.84,30.05,35.88,51.11,42.01c-21.06,6.13-42.69,23.17-51.11,42.01 c-9.11,20.37-8.71,47.13-8.32,57.12c0.4,9.99,1.58,26.76,1.98,32.35s1.28,12.15,5.34,15.13c2.33,1.71,9,5.19,58.52-11.68 c39.63-13.5,50.58-40.87,53.81-52.69c1.53-6.34,2.14-13.95,2.14-19.09v-64.42c0-0.07-0.01-0.15-0.01-0.22 c0-0.07,0.01-0.15,0.01-0.22V342.4c0-2.71,0-13.2-1.46-18.84C371.57,311.69,359.78,282.19,320.15,268.69z"
    })), /*#__PURE__*/ React.createElement("g", {
        className: specsClassName
    }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("polyline", {
        points: "701.35,109.62 701.35,106.62 698.35,106.62",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "692.24",
        y1: "106.62",
        x2: "560.89",
        y2: "106.62",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "557.84,106.62 554.84,106.62 554.84,109.62",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "554.84",
        y1: "115.77",
        x2: "554.84",
        y2: "248.02",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "554.84,251.1 554.84,254.1 557.84,254.1",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "563.95",
        y1: "254.1",
        x2: "695.3",
        y2: "254.1",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "698.35,254.1 701.35,254.1 701.35,251.1",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "701.35",
        y1: "244.94",
        x2: "701.35",
        y2: "112.7",
        vectorEffect: "non-scaling-stroke"
    }))), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("polyline", {
        points: "701.35,556.02 701.35,553.02 698.35,553.02",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "692.24",
        y1: "553.02",
        x2: "560.89",
        y2: "553.02",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "557.84,553.02 554.84,553.02 554.84,556.02",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "554.84",
        y1: "562.17",
        x2: "554.84",
        y2: "694.42",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "554.84,697.49 554.84,700.49 557.84,700.49",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "563.95",
        y1: "700.49",
        x2: "695.3",
        y2: "700.49",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "698.35,700.49 701.35,700.49 701.35,697.49",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "701.35",
        y1: "691.34",
        x2: "701.35",
        y2: "559.1",
        vectorEffect: "non-scaling-stroke"
    }))), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("polyline", {
        points: "252.32,109.62 252.32,106.62 249.32,106.62\t",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "243.21",
        y1: "106.62",
        x2: "111.86",
        y2: "106.62",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "108.8,106.62 105.8,106.62 105.8,109.62",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "105.8",
        y1: "115.77",
        x2: "105.8",
        y2: "248.02",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "105.8,251.1 105.8,254.1 108.8,254.1",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "114.91",
        y1: "254.1",
        x2: "246.26",
        y2: "254.1",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "249.32,254.1 252.32,254.1 252.32,251.1",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "252.32",
        y1: "244.94",
        x2: "252.32",
        y2: "112.7",
        vectorEffect: "non-scaling-stroke"
    }))), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("polyline", {
        points: "252.32,556.02 252.32,553.02 249.32,553.02",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "243.21",
        y1: "553.02",
        x2: "111.86",
        y2: "553.02",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "108.8,553.02 105.8,553.02 105.8,556.02",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "105.8",
        y1: "562.17",
        x2: "105.8",
        y2: "694.42",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "105.8,697.49 105.8,700.49 108.8,700.49",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "114.91",
        y1: "700.49",
        x2: "246.26",
        y2: "700.49",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "249.32,700.49 252.32,700.49 252.32,697.49",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "252.32",
        y1: "691.34",
        x2: "252.32",
        y2: "559.1",
        vectorEffect: "non-scaling-stroke"
    }))), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("line", {
        x1: "252.1",
        y1: "107.47",
        x2: "252.1",
        y2: "104.47",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "252.1",
        y1: "98.47",
        x2: "252.1",
        y2: "17.52",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "252.1",
        y1: "14.53",
        x2: "252.1",
        y2: "11.53",
        vectorEffect: "non-scaling-stroke"
    }))), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("line", {
        x1: "106.37",
        y1: "254.97",
        x2: "103.37",
        y2: "254.97",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "97.41",
        y1: "254.99",
        x2: "16.91",
        y2: "255.18",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "13.93",
        y1: "255.19",
        x2: "10.93",
        y2: "255.2",
        vectorEffect: "non-scaling-stroke"
    })))), /*#__PURE__*/ React.createElement("g", {
        className: specMarkersClassName
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M221.39,180.33c10.12-2.95,20.52-11.14,24.57-20.2c4.38-9.79,4.19-22.66,4-27.46s-0.76-12.87-0.95-15.55 c-0.19-2.69-0.62-5.84-2.57-7.27c-1.12-0.82-4.33-2.49-28.13,5.61c-19.05,6.49-24.72,20.67-26.2,26.38c-0.7,2.71-0.7,7.75-0.7,9.06 v28.62c0,0.04,0.01,0.07,0.01,0.11c0,0.04-0.01,0.07-0.01,0.11v30.97c0,2.47,0.3,6.13,1.03,9.18c1.55,5.68,6.82,18.84,25.87,25.33 c23.81,8.11,27.02,6.43,28.13,5.61c1.95-1.43,2.38-4.58,2.57-7.27c0.19-2.69,0.76-10.75,0.95-15.55s0.38-17.67-4-27.46 C241.91,191.47,231.51,183.27,221.39,180.33z M138.18,115.46c-23.81-8.11-27.02-6.43-28.13-5.61c-1.95,1.43-2.38,4.58-2.57,7.27 c-0.19,2.69-0.76,10.75-0.95,15.55s-0.38,17.67,4,27.46c4.05,9.06,14.45,17.25,24.57,20.2c-10.12,2.95-20.52,11.14-24.57,20.2 c-4.38,9.79-4.19,22.66-4,27.46s0.76,12.87,0.95,15.55c0.19,2.69,0.62,5.84,2.57,7.27c1.12,0.82,4.33,2.49,28.13-5.61 c19.05-6.49,24.32-19.65,25.87-25.33c0.73-3.05,1.03-6.71,1.03-9.18v-30.97c0-0.04-0.01-0.07-0.01-0.11c0-0.04,0.01-0.07,0.01-0.11 v-28.62c0-1.3,0-6.34-0.7-9.06C162.9,136.13,157.23,121.95,138.18,115.46z M143.24,69.72c-3.9,0-5.8-2.17-6.25-5.45h-3.85 c0.27,4.92,3.46,8.82,10.1,8.82c6.29,0,10.63-4.03,10.63-10.32c0-6.03-4.03-9.57-9.62-9.57c-3.19,0-5.23,1.24-6.6,2.92l0.75-9.7 h13.6l0.13-3.54h-17.02l-1.11,16.53l3.46,0.35c1.28-1.86,3.28-3.19,6.11-3.19c3.81,0,6.29,2.26,6.29,6.29 C149.89,67.29,146.96,69.72,143.24,69.72z M171.42,42.34c-7.27,0-11.48,6.6-11.48,15.46s4.12,15.29,11.34,15.29 c7.31,0,11.52-6.65,11.52-15.51C182.8,48.68,178.73,42.34,171.42,42.34z M171.37,69.64c-4.92,0-7.4-5.14-7.44-11.88 c0.04-6.74,2.53-11.96,7.44-11.96c4.96,0,7.4,5.1,7.4,11.83S176.33,69.64,171.37,69.64z M209.25,64.05c0,5.36,2.79,8.95,7.05,8.95 s7.05-3.59,7.05-8.95c0-5.05-2.79-8.46-7.05-8.46S209.25,59,209.25,64.05z M220.24,64.1c0,3.63-1.6,6.03-3.94,6.03 c-2.39,0-3.94-2.39-3.94-6.03c0-3.46,1.55-5.67,3.94-5.67C218.65,58.42,220.24,60.64,220.24,64.1z M202.52,50.89 c0-5.05-2.79-8.46-7.05-8.46c-4.3,0-7.05,3.41-7.05,8.46c0,5.36,2.75,8.95,7.05,8.95C199.73,59.84,202.52,56.25,202.52,50.89z M191.53,50.94c0-3.46,1.55-5.67,3.94-5.67c2.35,0,3.94,2.22,3.94,5.67c0,3.63-1.59,6.03-3.94,6.03 C193.08,56.96,191.53,54.57,191.53,50.94z M198,72.56l19.23-29.78h-3.15l-19.28,29.78H198z"
    })), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        d: "M252.1,11.93c-1.04,1.04-3.11,1.54-4.54,1.58c1.92-1.43,3.6-3.29,4.54-5.55c0.9,2.25,2.68,4.03,4.54,5.55 C255.11,13.39,253.25,13.01,252.1,11.93z",
        vectorEffect: "non-scaling-stroke"
    }))), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        d: "M11.33,255.2c1.05,1.04,1.55,3.11,1.6,4.54c-1.44-1.92-3.3-3.6-5.56-4.53c2.25-0.91,4.03-2.69,5.54-4.56 C12.78,252.19,12.41,254.05,11.33,255.2z",
        vectorEffect: "non-scaling-stroke"
    })))));
};
export default LogoMarkClearanceSVG;
